import { useCallback } from 'react';
import { useShallow } from 'zustand/shallow';
import { useGeo } from '../../../../GeoTargeting/GeoProvider';
import { useOffersFilterStore } from '../store';
import { DesktopFilters, type DesktopFiltersProps } from './index';

export const DesktopFiltersWithGeo: React.FC<DesktopFiltersProps> = props => {
  const { setRegionCode, initialRegionCode, regionCode, isReady } = useGeo();
  const { handleClearFiltersWithGeo } = useOffersFilterStore(
    useShallow(state => ({
      handleClearFiltersWithGeo: state.handleClearFiltersWithGeo,
    })),
  );

  const handleClearFiltersWithGeoWrapper = useCallback(() => {
    handleClearFiltersWithGeo(initialRegionCode || 'CA', setRegionCode);
  }, [initialRegionCode, regionCode, handleClearFiltersWithGeo, setRegionCode]);

  return (
    <DesktopFilters
      {...props}
      onClearFilters={handleClearFiltersWithGeoWrapper}
      initialClientRegion={initialRegionCode}
      showFilterSkeleton={!isReady}
      regionCode={regionCode}
    />
  );
};
